import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-h6" }, "Справка", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Параметры:", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " {event} - Тип события (reg - при регистрации, first_dep - при первом депозите, revshare - при доходе по ревшаре) ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "{campaign_id} - ID кампании", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "{status} - Статус (approved, pending, hold, rejected, trash)", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, " {payout} - Сумма поступления (CPA - сумма дохода, RevShare доход за каждый час) ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "{revamount}- Общий доход по RevShare", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "{currency} - Валюта поступления (usd, eur, rub, uah)", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "{date} - unix timestamp генерации действия", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "{sub1} - Sub ID 1", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, "{sub2} - Sub ID 2", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, "{sub3} - Sub ID 3", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, "{sub4} - Sub ID 4", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, "{sub5} - Sub ID 5", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "{sub6} - Sub ID 6", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, "{sub7} - Sub ID 7", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, "{sub8} - Sub ID 8", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, "{sub9} - Sub ID 9", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, "{sub10} - Sub ID 10", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, "{sub11} - Sub ID 11", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", null, "{sub12} - Sub ID 12", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", null, "{sub13} - Sub ID 13", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", null, "{sub14} - Sub ID 14", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", null, "{sub15} - Sub ID 15", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: _ctx.showDialog,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showDialog) = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { dark: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "row justify-between items-center" }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createElementVNode("div", null, [
                _createVNode(_component_q_btn, {
                  "no-caps": "",
                  icon: "close",
                  flat: "",
                  rounded: "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "q-pt-none" }, {
            default: _withCtx(() => [
              _createTextVNode(" Информация по настройке Postback ")
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "q-pt-none" }, {
            default: _withCtx(() => [
              _hoisted_2,
              _hoisted_3,
              _hoisted_4,
              _hoisted_5,
              _hoisted_6,
              _hoisted_7,
              _hoisted_8,
              _hoisted_9,
              _hoisted_10,
              _hoisted_11,
              _hoisted_12,
              _hoisted_13,
              _hoisted_14,
              _hoisted_15,
              _hoisted_16,
              _hoisted_17,
              _hoisted_18,
              _hoisted_19,
              _hoisted_20,
              _hoisted_21,
              _hoisted_22,
              _hoisted_23,
              _hoisted_24
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, { align: "right" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                "no-caps": "",
                flat: "",
                label: "OK",
                color: "primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}